export const BOOKINGS_APP_DEF_ID = '13d21c63-b5ec-5912-8397-c3a5ddb27a97';
export const BOOKINGS_SERVICE_PAGE_SECTION_ID = 'Booking Service Page';
export const BOOKINGS_CHECKOUT_SECTION_ID = 'book_checkout';
export const BOOKINGS_SCHEDULER_SECTION_ID = 'scheduler';
export const BOOKINGS_CALENDAR_SECTION_ID = 'Booking Calendar';
export const PRICING_PLAN_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
export const PRICING_PLAN_SECTION_ID = 'membership_plan_picker_tpa';
export const BOOKINGS_LIST_SECTION_ID = 'bookings_list';
//# sourceMappingURL=const.js.map